import React, { useState } from 'react'
import { Lexicon } from '@nitidbit/lexicon'

import SearchCheckbox from '../search/SearchCheckbox/SearchCheckbox.jsx'
import SearchInputField from '../search/SearchInputField/SearchInputField.jsx'
import SearchSelectDropdown from '../search/SearchSelectDropdown/SearchSelectDropdown.jsx'
import SearchDatePicker from '../search/SearchDatePicker/SearchDatePicker.jsx'
import SearchForm from '../search/SearchForm/SearchForm.jsx'
import SearchFormBar from '../search/SearchForm/SearchFormBar.jsx'
import SearchSubmitButton from '../search/SearchSubmitButton/SearchSubmitButton.jsx'
import InfoTooltip from '../shared_components/InfoTooltip/InfoTooltip'

import './AbortionFinderForm.scss'

import locationIcon from './location_icon_white.svg'
import calendarIcon from './calendar_icon.svg'

import lexiconRaw from './AbortionSearchStrings.json'

const locale = document.documentElement.lang || 'en'
const lexicon = new Lexicon(
  lexiconRaw,
  locale,
  'bedsider/app/javascript/components/search/AbortionFinder/AbortionSearchStrings.json'
)
const abfinderLexicon = lexicon.subset('searchbar')

const ageOptions = ['18 or older', '17', '16', '15 or younger'].map((value) => {
  return {
    value,
    text: abfinderLexicon.subset('ages').get(value),
  }
})

const AbortionFinderForm = ({ abfinderSearchUrl, forceStacked = false }) => {
  const [location, setLocation] = useState('')
  const [lmpDate, setLmpDate] = useState(null)
  const [age, setAge] = useState(ageOptions[0].value)
  const [isLmpUnknown, setIsLmpUnknown] = useState(false)

  const MAX_DAYS_SINCE_LMP = 40 * 7 // 40 weeks

  const handleUnknownLmpToggle = (newValue) => {
    if (newValue) setLmpDate(null)
    setIsLmpUnknown(newValue)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()

    const searchUrl = encodeURI(
      `${abfinderSearchUrl}?location=${location}&age=${age}&lmpepoch=${
        lmpDate ? lmpDate.valueOf() : 'unsure'
      }`
    )
    window.open(searchUrl, '_blank')
  }

  const isSearchSubmitDisabled =
    location.trim().length === 0 || (!lmpDate && !isLmpUnknown)

  return (
    <div className="AbortionFinderForm">
      <SearchForm
        title={abfinderLexicon.get('header')}
        forceStacked={forceStacked}
      >
        <SearchFormBar forceStacked={forceStacked}>
          <SearchInputField
            value={location}
            setValue={setLocation}
            label={abfinderLexicon.get('location_label')}
            placeholder={abfinderLexicon.get('location_placeholder')}
            icon={locationIcon}
            forceStacked={forceStacked}
            enableAutofocus={false}
          />
          <SearchDatePicker
            value={lmpDate}
            setValue={setLmpDate}
            label={abfinderLexicon.get('lmp_label')}
            placeholder={abfinderLexicon.get('lmp_placeholder')}
            calendarTitle={abfinderLexicon.get('lmp_calendar_question')}
            maxDaysInThePast={MAX_DAYS_SINCE_LMP}
            icon={calendarIcon}
            forceStacked={forceStacked}
            locale={locale}
            lexicon={abfinderLexicon}
            disabled={isLmpUnknown}
            infoTooltip={
              <InfoTooltip
                tooltipTitle={abfinderLexicon.get('lmp_tooltip_title')}
                tooltipContent={abfinderLexicon.get('lmp_tooltip_content')}
                tooltipCloseText={abfinderLexicon.get('tooltip_close')}
              />
            }
          />

          <SearchSelectDropdown
            value={age}
            setValue={setAge}
            label={abfinderLexicon.get('age_label')}
            options={ageOptions}
            icon={calendarIcon}
            forceStacked={forceStacked}
            infoTooltip={
              <InfoTooltip
                tooltipTitle={abfinderLexicon.get('age_tooltip_title')}
                tooltipContent={abfinderLexicon.get('age_tooltip_content')}
                tooltipCloseText={abfinderLexicon.get('tooltip_close')}
              />
            }
          />
        </SearchFormBar>

        <SearchCheckbox
          value={isLmpUnknown}
          setValue={handleUnknownLmpToggle}
          label={abfinderLexicon.get('lmp_unsure')}
          forceStacked={forceStacked}
        />

        <SearchSubmitButton
          text={abfinderLexicon.get('submit')}
          onClick={handleSearchSubmit}
          isExternalLink={true}
          forceStacked={forceStacked}
          disabled={isSearchSubmitDisabled}
        />

        <p className="privacy">{lexicon.subset('search').get('disclaimer')}</p>
      </SearchForm>
    </div>
  )
}

export default AbortionFinderForm
